import { OrderGroupDto } from '@services/src/models';

export const IsOldProcess = (orderGroup: OrderGroupDto) =>
	orderGroup.year && orderGroup.year < 2024;
